import {baseQaConfig} from '../base/qa.config';
import {cbsnewsDevConfig} from './dev.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cbsnewsQaConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseQaConfig, cbsnewsDevConfig, {
  environmentName: 'Cbs News QA Environment',
  ionicEnvName: 'qa',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cbsnews/qa.config.ts